module.exports = __webpack_public_path__ + "assets/ic-youtube.f1130e26.svg";